import { Injectable } from '@angular/core';
import { DFPService } from '@services/http/dfp/dfp.service';

/**
 * A DFP Histórica lida pelo deal, para o PARCEIRO (card 3307, T03).
 *
 * O parceiro não tem `DFP_VIEW` e não pode ganhar: os endpoints `dfp-historical/*` recebem o `companyId`
 * solto e abririam a DFP de qualquer empresa. O backend expõe as mesmas tabelas em
 * `partners/deals/{dealId}/economic-analysis/*`, com os mesmos contratos e o mesmo `?periods=`, conferindo
 * que o deal é de quem pede e tirando a empresa do próprio deal. Esta classe só troca a base das rotas;
 * o `companyId` que a tela continua mandando é ignorado lá.
 *
 * Fornecida SÓ na subárvore da aba do parceiro (`DealPartnerEconomicAnalysisTabComponent`), que chama
 * {@link useDeal} antes de a DFP embutida carregar.
 */
@Injectable()
export class PartnerDealDfpService extends DFPService {
  useDeal(dealId: string): void {
    this.historicalBaseUrl = `partners/deals/${dealId}/economic-analysis`;
  }
}
